var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-header-base',[_c('div',{staticClass:"h-100 d-flex ai-center jc-end"},[_c('span',{staticClass:"h6 c-white"},[_vm._v("Call us for support 1-855-723-2266")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }